<template>
  <!-- Modal -->
  <div ref="modalDetail" class="modal fade" id="SinglePaymentsModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{ translations('common.addition') }}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <table class="table table-striped table-align-middle">
            <thead>
              <tr>
                <th>{{ translations('invoice.transfer_fee') }}</th>
                <th>{{ translations('invoice.item_name') }}</th>
                <th>{{ translations('deposit.amount_money') }}</th>
              </tr>
            </thead>
            <tbody class="nowrap">
              <tr>
                <td><input class='form-control-sm' v-model="tempDetail.is_fee" type='checkbox'></td>
                <td><input class='form-control form-control-sm' v-model="tempDetail.item_name" type='text'></td>
                <td><input class='form-control form-control-sm' v-model="tempDetail.paid" type='text'></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{translations('common.close')}}</button>
          <button type="button" class="btn btn-primary" @click="updateDetails()">{{translations('common.update')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SinglePaymentsModal',
  props: {
    details: {}
  },
  data: function () {
    return {
      tempDetail: {}
    }
  },
  watch: {
  },
  created: function () {
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    emptyTempDetail: function () {
      this.tempDetail = {}
    },
    updateDetails: function () {
      if (this.tempDetail.item_name === undefined || this.tempDetail.item_name.trim() === '') {
        this.$toastr.warning(this.translations('deposit.notice_enter_name_deduction'))
        return
      }

      if (isNaN(parseInt(this.tempDetail.paid))) {
        this.$toastr.warning(this.translations('deposit.notice_enter_amount_half_width_numbers'))
        return
      }

      this.$props.details.push(this.tempDetail)
      this.emptyTempDetail()

      this.$refs.closeModal.click()
    }
  }
}
</script>
